import cx from 'classnames'
import { useMemo } from 'react'

import classes from './styles.module.scss'

type Props = {
  tag: string
  isDarkMode: boolean
}

const RIBON_WIDTH = 56

export default function OfferTagRibon({ tag, isDarkMode }: Props) {
  const fontSize = useMemo(() => {
    const charAmount = tag.length

    // Double RIBON_WIDTH to take in count 2 lines as per design
    return (RIBON_WIDTH * 2) / charAmount
  }, [tag])

  const hasWhiteSpaces = tag.includes(' ')

  return (
    <div className={classes.root}>
      <svg width='66' height='55' viewBox='0 0 66 55' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M9.12297 2.8267L0.174805 2.8267C0.19733 2.55307 0.349376 1.91302 1.46719 1.31009C2.01906 1.0124 2.63569 0.816466 3.10309 0.694092L9.12297 0.694092L9.12297 2.8267Z'
          fill='#008631'
        />
        <path
          d='M56.4204 2.8267L65.3686 2.8267C65.346 2.55307 65.194 1.91302 64.0762 1.31009C63.5243 1.0124 62.9077 0.816466 62.4403 0.694092L56.4204 0.694092L56.4204 2.8267Z'
          fill='#008631'
        />
        <g filter='url(#filter0_ii_36955_25028)'>
          <path
            d='M5.92725 4.66659C5.92725 2.75979 3.79673 1.22375 2.73148 0.694089L62.812 0.694092C60.7667 1.75342 59.8293 3.60726 59.6162 4.40175L59.6162 54.72L33.4109 45.5611L5.92725 54.72L5.92725 4.66659Z'
            fill='url(#paint0_linear_36955_25028)'
          />
        </g>
        <defs>
          <filter
            id='filter0_ii_36955_25028'
            x='2.73145'
            y='0.694092'
            width='60.0806'
            height='54.0259'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='1.34492' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.42 0' />
            <feBlend mode='normal' in2='shape' result='effect1_innerShadow_36955_25028' />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='-1.34492' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
            <feBlend mode='normal' in2='effect1_innerShadow_36955_25028' result='effect2_innerShadow_36955_25028' />
          </filter>
          <linearGradient
            id='paint0_linear_36955_25028'
            x1='62.812'
            y1='54.72'
            x2='54.3724'
            y2='-6.43281'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#1BEE02' />
            <stop offset='1' stop-color='#00AD45' />
          </linearGradient>
        </defs>
      </svg>
      <span
        style={{ fontSize: `${fontSize}px` }}
        className={cx(classes.text, !hasWhiteSpaces && classes.breakAll, !isDarkMode && classes.textLightMode)}
      >
        {tag}
      </span>
    </div>
  )
}
